import lodashUtil from 'lodash'
import format from 'date-fns/format';
import theme from '../../../../assests'


const anHour = 60;
const blocketUnit = anHour / 24;
const minimumBreakBlocketCount = 6;

export const getTimeTableSlots = (calenderData) => {

  let timeTableSlots7 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let timeTableSlots1 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let timeTableSlots2 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let timeTableSlots3 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let timeTableSlots4 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let timeTableSlots5 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let timeTableSlots6 = Array.apply(null, new Array(24)).map(function (el, i) { return { "timeBlock": i++ } })
  let outputArray = [
    {
      "day": "Mon",
      "dayNumber": 1,
      "timeSlots": [...timeTableSlots1]
    },
    {
      "day": "Tue",
      "dayNumber": 2,
      "timeSlots": [...timeTableSlots2]
    },
    {
      "day": "Wed",
      "dayNumber": 3,
      "timeSlots": [...timeTableSlots3]
    },
    {
      "day": "Thu",
      "dayNumber": 4,
      "timeSlots": [...timeTableSlots4]
    },
    {
      "day": "Fri",
      "dayNumber": 5,
      "timeSlots": [...timeTableSlots5]
    },
    {
      "day": "Sat",
      "dayNumber": 6,
      "timeSlots": [...timeTableSlots6]
    },
    {
      "day": "Sun",
      "dayNumber": 0,
      "timeSlots": [...timeTableSlots7]
    }
  ]
  calenderData.periodsDetails.forEach((dayObj) => {
    dayObj.periods.forEach((period) => {
      //let startDateObject = new Date(period.startTime);
      //let endDateObject = new Date(period.endTime);

      let startDateObject = getDayForHourAndMin(period.startTime_str);
      let endDateObject = getDayForHourAndMin(period.endTime_str);
      let startHour = startDateObject.getHours();
      //let startHour = period.startTime_str.split(":")[0] % 12;

      let startMinutes = startDateObject.getMinutes();


      let outputArrayDayIndex = lodashUtil.findIndex(outputArray, { 'dayNumber': Number(dayObj.dayNumber) });
      let dayTimeSlotIndex = lodashUtil.findIndex(outputArray[outputArrayDayIndex].timeSlots, { 'timeBlock': startHour });
      let blocketConfig = {};

      blocketConfig.startingBlocket = (startMinutes / blocketUnit) + 1;
      blocketConfig.totalBlocks = (period.duration / blocketUnit);
      blocketConfig.label = `${format(startDateObject, 'hh:mm')} - ${format(endDateObject, 'hh:mm a')} ${period.periodName}`
      blocketConfig.style = period.typeOfPeriod === "period" ?
        theme.palette.primary.lighter
        :
        theme.palette.grey.dark;

      if (period.typeOfPeriod === 'break') {
        if (blocketConfig.totalBlocks < minimumBreakBlocketCount) {
          blocketConfig.isBreakLessThan15Min = true
        }
      }

      blocketConfig.period = period;

      if (outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration != undefined
        && outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.length > 0) {
        outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);
      } else {
        outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration = [];
        outputArray[outputArrayDayIndex].timeSlots[dayTimeSlotIndex].blockletConfiguration.push(blocketConfig);
      }
    })
  })
  return outputArray;
}

export const getDayForHourAndMin = (hourMinString) => {
  let aday =  new Date(1970, 0, 1);
  if (hourMinString) {
    let strArray = hourMinString.split(":");
    aday.setHours(strArray[0]);
    aday.setMinutes(strArray[1])
  }
  return aday;
}
export const getHourMinStr = (adate) => {
  if (typeof adate === "number") {
    adate = new Date(adate);
  }
  let m = adate.getMinutes();
  let h = adate.getHours();
  m = m < 10 ? '0' + m : m;
  h = h < 10 ? '0' + h : h;
  return h + ":" + m;

}
export const periodNaming = (sortedPeriod) => {
  let updatedPeriodName = sortedPeriod;
  let periodCount = 0;
  let lunchCount = 0;
  let breakCount = 0;
  let multipleBreakPeriod = false;
  let multipleLunchPeriod = false;
  let breakArray = lodashUtil.filter(sortedPeriod, ["typeOfPeriod", "break"]);
  if (breakArray.length > 1) {
    multipleBreakPeriod = true;
  }
  let lunchArray = lodashUtil.filter(sortedPeriod, ["typeOfPeriod", "lunch"]);
  if (lunchArray.length > 1) {
    multipleLunchPeriod = true;
  }

  for (let i = 0; i < updatedPeriodName.length; i++) {
    if (updatedPeriodName[i].typeOfPeriod === 'period') {
      ++periodCount
      updatedPeriodName[i].periodName = `Period${periodCount}`;
    }
    else if (updatedPeriodName[i].typeOfPeriod === 'lunch') {
      lunchCount++
      if (multipleLunchPeriod === true) {
        updatedPeriodName[i].periodName = `Lunch${lunchCount}`;
      } else {
        updatedPeriodName[i].periodName = `Lunch`
      }
    }
    else if (updatedPeriodName[i].typeOfPeriod === 'break') {
      breakCount++;
      if (multipleBreakPeriod === true) {
        updatedPeriodName[i].periodName = `Break${breakCount}`;
      } else {
        updatedPeriodName[i].periodName = `Break`
      }
    }
  }
  let tempObj = {
    updatedPeriodName: updatedPeriodName,
    periodCount: periodCount,
    lunchCount: lunchCount,
    breakCount: breakCount,
  }
  return tempObj;
}

//This is a temporary method to make use of old data
export const populatePeriodTimeStrs = (calendar) => {
  let periodsDetials = calendar.periodsDetails;
  periodsDetials.forEach(dayObj => {
    dayObj.periods.forEach(period => {
      if (!period.startTime_str) {
        if (typeof period.startTime == "number") {
          period.startTime_str = getHourMinStr(new Date(period.startTime));
          period.endTime_str = getHourMinStr(new Date(period.endTime));
        }
      }
    });
  });
  return calendar;
}
export const calculateTotalPeriods = (calendar) => {
  let periodsDetials = calendar.periodsDetails;
  let totalPeriods = 0
  // this.state.totalPeriods;
  let firstPeriodStartTime = null
  let lastPeriodEndTime = null
  for (let i = 0; i < periodsDetials.length; i++) {
    let dayObj = periodsDetials[i];
    for (let k = 0; k < dayObj.periods.length; k++) {
      if (dayObj.periods[k].typeOfPeriod == "period") {
        totalPeriods++;
      }
      if (i == 0 & k == 0) {
        firstPeriodStartTime = periodsDetials[i].periods[k].startTime
        lastPeriodEndTime = periodsDetials[i].periods[k].endTime
      }
      else {
        if (periodsDetials[i].periods[k].startTime < firstPeriodStartTime) {
          firstPeriodStartTime = periodsDetials[i].periods[k].startTime
        }
        if (periodsDetials[i].periods[k].endTime > lastPeriodEndTime) {
          lastPeriodEndTime = periodsDetials[i].periods[k].endTime
        }
      }
    }
  }

  //first and last slot calculation
  let firstPeriodStartTimeObject = new Date(firstPeriodStartTime);
  let startHourSlot = firstPeriodStartTimeObject.getHours()
  let lastPeriodEndTimeObject = new Date(lastPeriodEndTime);
  let lastHourSlot = lastPeriodEndTimeObject.getHours()
  let lastMinute = lastPeriodEndTimeObject.getMinutes()
  if (lastMinute == 0) {
    lastHourSlot--
  }
  return { totalPeriods: totalPeriods, startHourSlot: startHourSlot, lastHourSlot: lastHourSlot };
}

export const calculateNumberOfDays = (calendar) => {
  let calendarData = getTimeTableSlots(calendar);
  let periodsDetails = calendar.periodsDetails
  let numberOfDays = 0
  let dayName = [];
  let displayingString = ""
  for (let a = 0; a < periodsDetails.length; a++) {
    let dayObj = periodsDetails[a]
    let dayNumber = dayObj.dayNumber;
    if (dayObj.periods.length > 0) {
      numberOfDays++
    }
    let periodObj = lodashUtil.find(calendarData, ["dayNumber", dayNumber]);
    if (periodObj != undefined) {
      dayName.push(periodObj.day);
    }
  }
  dayName = dayName.toString()
  displayingString = `${numberOfDays} days - ${dayName} `
  return displayingString;
}
